import { treaty, type Treaty } from "@elysiajs/eden";

import { type API as APIType } from "./src/index";

export type API = APIType;

/** Typed Eden client for this API; use when a consumer cannot reference `treaty<API>` (e.g. duplicate elysia). */
export type ApiTreatyClient = Treaty.Create<API>;

// this custom onResponse is a workaround to avoid automatic date parsing by eden
// see issue: https://github.com/elysiajs/eden/issues/206
export const onResponse = async (response: Response) => {
	if (response.ok && response.headers.get("Content-Type")?.split(";")[0] === "application/json") {
		return response.json();
	}
};

export const getMobileClient = (host: string, headers: Record<string, string>) => {
	return treaty<API>(host, {
		fetch: {
			credentials: "include",
		},
		headers: {
			...headers,
			"x-classa-client": "mobile",
		},
		onResponse,
	});
};

